<template>
    <pvz-map :list="coordinates" :simple-mode="true"></pvz-map>
</template>

<script>
    import PvzMap from "./PvzMap";

    export default {
        name: "ContactMap",
        components: {PvzMap},
        props: ['coordinates']
    }
</script>